import React from 'react';
import MessageSection from './MessageSection/MessageSection.jsx';
import SidePanel from './SidePanel/SidePanel.jsx';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { selectedUserIdSelector } from '../../../selectors/userSelectors.js';
import { useGetUserInfoQuery } from '../../../api/userApi.js';
import { Stack } from '@mui/material';

const DashboardContent = () => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: userInfo } = useGetUserInfoQuery(selectedUserId, {
    skip: !selectedUserId
  });
  return (
    <Stack
      direction='row'
      sx={{
        m: 2,
        width: '100%',
        height: 'calc(100vh - 32px)',
        overflow: 'hidden'
      }}
    >
      {!isEmpty(userInfo) && (
        <>
          <MessageSection />
          <SidePanel />
        </>
      )}
    </Stack>
  );
};

export default DashboardContent;
